module.exports = __webpack_public_path__ + "static/media/Churned_Utid.16f15210.csv";